import { useEffect } from 'react';
import { Attention } from '@peacecover/icon';
import { t } from 'i18next';

const PaymentFailPage = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const provider = searchParams.get('provider');
  const reason = searchParams.get('reason');
  const isDebugEnv = import.meta.env.REACT_APP_DEPLOY_ENV === 'local';

  useEffect(() => {
    if (isDebugEnv) {
      return;
    }

    const timer = setTimeout(() => {
      window.close();
    }, 2000);

    return () => clearTimeout(timer);
  }, [isDebugEnv]);

  return (
    <div className="h-screen flex flex-col items-center justify-center gap-[17px]">
      <Attention size={82} className="text-on-warning" />
      <p className="text-[24px] font-semibold text-text-main-lv2 leading-[29px]">
        {t('Payment.fail')}
      </p>
      {isDebugEnv ? (
        <div className="px-[24px] text-center">
          <p className="text-[12px] leading-[16px] text-text-sub-lv1">
            debug mode: auto-close disabled
          </p>
          {provider ? (
            <p className="text-[12px] leading-[16px] text-text-sub-lv1 mt-[4px]">
              provider: {provider}
            </p>
          ) : null}
          {reason ? (
            <p className="text-[12px] leading-[16px] text-text-sub-lv1 mt-[4px]">
              reason: {reason}
            </p>
          ) : null}
          <button
            type="button"
            className="text-[12px] leading-[16px] text-text-sub-lv1 mt-[4px]"
            onClick={() => window.close()}
          >
            {t('common.close')}
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default PaymentFailPage;
